import { eCardBrand } from '../../SubscriptionManager.enums';
import { tPaymentMethodOption } from '../../SubscriptionManager.types';
import CardBrand from './CardBrand.component';
import { SingleValueProps } from 'react-select';

export default function CardSelectorSelectedValue(
  props: SingleValueProps<tPaymentMethodOption>,
) {
  const { innerProps, data } = props;
  return (
    <div
      {...innerProps}
      className="flex flex-row items-center px-1 absolute top-1/2 left-2 transform -translate-y-1/2"
    >
      <CardBrand brand={data.brand as eCardBrand} />
      <p className="SubscriptionCheckout__paymentMethods__selectedPaymentMethod__cardNumber ml-2 py-4">
        •••• •••• •••• {data.lastDigits}
      </p>
    </div>
  );
}
